import {Component, Input, OnInit} from '@angular/core';
import { ModalController} from '@ionic/angular';
import {ActivatedRoute} from "@angular/router";
import {OfferInfo} from "~/app/core/model/offer-info";
import {CoreService} from "~/app/core/core.service";

@Component({
  selector: 'app-modal',
  templateUrl: './createAccountDialog.component.html',
  styleUrls: ['./createAccountDialog.component.scss'],
})

export class CreateAccountDialogComponent implements OnInit {

  @Input() offerId: number;
  @Input() offer: OfferInfo;
  constructor(
    public modalCtrl: ModalController,
    private readonly route: ActivatedRoute,
    private readonly core: CoreService,
  ) {
  }

  ngOnInit() {
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
